// ─── Single source of truth for ad-platform identity across the client ───
// One entry per ad CHANNEL the campaign form can target. `value`/`label` are the
// capitalized display strings the form already stores (do not change casing —
// formData keys like publisherPlatform.includes('TikTok') depend on them).
//
// `connectionSlugs` = the ad_auth_configs.name value(s) written by the server
// (server/src/routes/auth/*AdsAuthRoutes.js) that count as "connected" for this
// channel. Meta covers Facebook + Instagram; Shopify is satisfied by EITHER the
// manual 'shopify' key flow OR the 'shopify-oauth' OAuth flow — this array is
// what fixes BUG-001 (Shopify-OAuth users seeing the option disabled).
import {
  FaFacebook, FaInstagram, FaTiktok, FaGoogle,
  FaSnapchatGhost, FaLinkedin, FaShopify, FaBullhorn,
} from 'react-icons/fa';

export const PLATFORMS = [
  { value: 'Facebook',  label: 'Facebook',  Icon: FaFacebook,      color: '#1877F2', connectionSlugs: ['meta'] },
  { value: 'Instagram', label: 'Instagram', Icon: FaInstagram,     color: '#E4405F', connectionSlugs: ['meta'] },
  { value: 'TikTok',    label: 'TikTok',    Icon: FaTiktok,        color: '#010101', connectionSlugs: ['tiktok'] },
  { value: 'Google',    label: 'Google',    Icon: FaGoogle,        color: '#4285F4', connectionSlugs: ['google'] },
  { value: 'Snapchat',  label: 'Snapchat',  Icon: FaSnapchatGhost, color: '#FFFC00', connectionSlugs: ['snapchat'] },
  { value: 'LinkedIn',  label: 'LinkedIn',  Icon: FaLinkedin,      color: '#0A66C2', connectionSlugs: ['linkedin'] },
  { value: 'Shopify',   label: 'Shopify',   Icon: FaShopify,       color: '#95BF47', connectionSlugs: ['shopify', 'shopify-oauth'] },
  { value: 'Taboola',   label: 'Taboola',   Icon: FaBullhorn,      color: '#0768E1', connectionSlugs: ['taboola'] },
];

// True if any of a channel's backing slugs is in the connected set.
// `connected` may be a Set or an array of slugs.
export const isChannelConnected = (value, connected) => {
  const has = connected instanceof Set
    ? (s) => connected.has(s)
    : (s) => Array.isArray(connected) && connected.includes(s);
  const channel = PLATFORMS.find((p) => p.value === value);
  return !!channel && channel.connectionSlugs.some(has);
};

// Display labels for a given ad_auth_configs slug (reverse of connectionSlugs).
// e.g. 'meta' → ['Facebook', 'Instagram']; unknown slug → [slug] (safe fallback).
export const labelsForSlug = (slug) => {
  const labels = PLATFORMS.filter((p) => p.connectionSlugs.includes(slug)).map((p) => p.label);
  return labels.length ? labels : [slug];
};
